import type { EventPageRelatedEvent } from '../data/types'
import styles from './Lists.module.css'

export function RelatedEvents({ events }: { events: EventPageRelatedEvent[] }) {
  if (!events.length) return null
  return (
    <div className={styles.section}>
      <h2 className={styles.heading}>More at this track</h2>
      <div className={styles.relatedGrid}>
        {events.map((e) => (
          <a key={e.id} href={`/events/displayEvent.cfm?ID=${e.id}`} className={styles.relatedCard}>
            {e.flyerUrl ? <img src={e.flyerUrl} alt="" className={styles.relatedImg} /> : null}
            <div className={styles.relatedBody}>
              <div className={styles.relatedName}>{e.name}</div>
            </div>
          </a>
        ))}
      </div>
    </div>
  )
}
